export default {
  uploadingLogo: 'Subiendo logo',
  cancel: 'Cancelar',
  modelSettings: 'Configuración del modelo:',
  save: 'Guardar',
  displayTab: 'Apariencia',
  customNamesTab: 'Nombres Personalizados',
  metadataTab: 'Metadatos',
  channelTaxonomyTab: 'Taxonomía de Canales',
  channelTaxonomyChannels: 'Canales',
  channelTaxonomyNoChannels: 'Este modelo no tiene canales de medios.',
  taxonomyLevelL0: 'Peso',
  taxonomyLevelL1: 'Estrategia',
  taxonomyLevelL2: 'Definición',
  taxonomyLevelL3: 'Apertura',
  taxonomyLevelL4: 'Formato',
  taxonomyLevelL5: 'Proveedor',
  taxonomyLevelL6: 'Personalizado',
  taxonomySelectParentFirst: 'Selecciona {parent} primero',
  metadataClient: 'Cliente',
  metadataBrand: 'Marca',
  metadataCategory: 'Categoría',
  metadataSubCategory: 'Subcategoría',
  metadataCountry: 'País',
  addValueTitle: 'Agregar nuevo valor',
  addValueButton: 'Agregar',
  addValueTooltip: 'Agregar un nuevo valor',
  addValueAbbreviationLabel: 'Abreviación',
  addValueAbbreviationNoSpaces: 'La abreviación no puede contener espacios',
  prettyMediaNames: 'Nombres de Medios',
  originalName: 'Nombre Original',
  displayName: 'Nombre a Mostrar',
  prettyComponentNames: 'Nombres de Componentes',
  addPrettyComponentName: 'Agregar Nombre de Componente',
  delete: 'Eliminar',
  prettyExternalVariableNames: 'Nombres de Variables Externas',
  addExternalVariableName: 'Agregar Nombre de Variable Externa',
  primaryColor: 'Color Primario',
  primaryColorLabel: 'Color Primario (ej. #FF0000)',
  customKpiName: 'Nombre de KPI (reemplaza "Ventas")',
  customKpiNameLabel: 'Nombre de KPI Personalizado',
  logo: 'Logo',
  hiddenKpis: 'KPIs ocultos',
  hiddenKpisLabel: 'KPIs a ocultar',
  hiddenKpisHint: 'Los KPIs ocultos no se muestran a ningún usuario en el Model Report, los planes, el What-If ni Compare Plans. Mientras haya algún KPI oculto, también se oculta el Total.',
  hiddenKpisAtLeastOne: 'Al menos un KPI debe quedar visible',
  chooseLogoFile: 'Elegir nuevo archivo de logo (PNG/JPG)',
  deleteLogo: 'Eliminar logo',
  required: 'Requerido',
  duplicatedMediaName: 'Nombre de medio duplicado',
  invalidPrimaryColor: 'Color Primario inválido',
  errorUploadingLogo: 'Error al subir el logo',
  componentNamesEmptyError: 'Los nombres personalizados de componentes no pueden tener valores vacíos',
  componentNamesDuplicateError: 'Los nombres personalizados de componentes no pueden tener nombres originales duplicados',
  externalVariablesEmptyError: 'Los nombres personalizados de variables externas no pueden tener valores vacíos',
  externalVariablesDuplicateError: 'Los nombres personalizados de variables externas no pueden tener nombres originales duplicados',
  errorUpdatingSettings: 'Error al actualizar la configuración'
}
